import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=20a5aa98&scoped=true"
import script from "./loading-bar.ts?vue&type=script&lang=ts&external"
export * from "./loading-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=20a5aa98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a5aa98",
  null
  
)

export default component.exports